import React from 'react'
import PropTypes from 'prop-types'
import {MenuItem} from '@material-ui/core'

const Option = React.memo(({classes, ...props}) => {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      classes={{root: classes.menuOption, selected: classes.selectedOption}}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  )
})

Option.propTypes = {
  classes: PropTypes.object.isRequired,
  innerRef: PropTypes.any,
  isFocused: PropTypes.bool,
  innerProps: PropTypes.object,
  children: PropTypes.node,
}

export default Option
